import Button, { type ButtonProps } from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';

export type ErrorLayoutProps = {
	title: string;
	description: string;
	buttonText: string;
	fullScreen?: boolean;
	children?: React.ReactNode;
	buttonProps?: Omit<ButtonProps, 'children' | 'size'>;
};

const DescriptionArea = ({
	title,
	description,
}: {
	title: string;
	description: string;
}) => {
	return (
		<div className="flex flex-col justify-center gap-y-10 items-center text-center">
			<Typography variant="h6" fontWeight="medium">
				{title}
			</Typography>
			<Typography variant="body-sm">{description}</Typography>
		</div>
	);
};

export const ErrorLayout = ({
	title,
	description,
	buttonText,
	buttonProps,
	fullScreen,
	children,
}: ErrorLayoutProps) => {
	if (fullScreen) {
		return (
			<div className="flex flex-col justify-center items-center h-screen bg-primary">
				{children}
				<div className="flex flex-col justify-center items-center p-20 gap-y-20">
					<DescriptionArea title={title} description={description} />
					<Button size="lg" {...buttonProps}>
						{buttonText}
					</Button>
				</div>
			</div>
		);
	}
	return (
		<div className="flex flex-col">
			<div className="flex flex-col gap-10 px-20 py-30">
				{children}
				<DescriptionArea title={title} description={description} />
			</div>
			<div className="py-10 flex justify-center">
				<Button size="lg" {...buttonProps}>
					{buttonText}
				</Button>
			</div>
		</div>
	);
};
